module.exports = __webpack_public_path__ + "img/buddy_mouth-04.f0618e95.svg";